<template>    
<!-- ページ内ヘッダ -->
	<!-- <div v-if="(login.sex)">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li class="selected">一覧表示</li>
			<li>申込理由/活動日程選択</li>
			<li>内容確認</li>
			<li>申込完了</li>
		</ul>
	</div> -->
	<div v-if="(login.sex)" class="center mosi_pan">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li class="selected">活動選択</li>
			<li>申込理由/活動日程選択</li>
			<li>内容確認</li>
		</ul>
	</div>
    <div>
		<!-- 検索エリア -->
        <div class="search_area hidden_box">
                <!-- <p>条件で検索できます</p> -->
			<!-- <h2>条件で絞り込む</h2> -->
			<label class="hidden_label"><fa icon="chevron-down" class="icon" />&ensp;募集要項検索</label>
			<!-- <label for="hidden" class="hidden_label"><fa icon="chevron-down" class="icon" />&ensp;募集要項検索はこちらから<br class="search_message_off"><span class="search_message">ここをクリック！</span></label> -->
			<!-- memo -->
			<!-- <p>memo:（検索条件追加？）</p> -->
			<div class="hidden_show">
				<div class="inner">
					<dl>
						<div class="flex inner_dl">
							<dt><label for="katudo_bunya">活動分野</label></dt>
							<dd>
								<select id="katudo_bunya" v-model="bunya">
									<option value="">---</option>
									<template v-for="bunya in bunya_lists" :key="bunya.code">
										<option :value="bunya.code">{{ bunya.name }}</option>
									</template>
								</select>
							</dd>
						</div>
						<div class="flex inner_dl">
							<dt><label for="sisetu_name">施設名</label></dt>
							<dd><input type="text" id="sisetu_name" v-model="sisetu_name"></dd>
						</div>
						<div class="flex inner_dl">
							<dt><label>活動期間</label></dt>
							<dd class="kikan_search flex">
								<span class="search_katudo_off">開始：</span>
								<!-- <input type="date" class="date_period" v-model="kikan_from"> -->
								<DatePicker v-model="kikan_from_d" class="input_birth" color="teal" :popover="popover" :masks="masks">
									<template v-slot="{ inputValue, inputEvents, togglePopover}">
										<input :value="inputValue" v-on="inputEvents">
										<button class="icon-calendar" @click="togglePopover" type="button"><fa :icon="['far','calendar-alt']" class="icon fa-2x" /></button>
									</template>
								</DatePicker>
								<span class="search_katudo_on"> ～ </span>
								<span class="search_katudo_off">終了：</span>
								<!-- <input type="date" class="date_period" v-model="kikan_to"> -->
								<DatePicker v-model="kikan_to_d" class="input_birth" color="teal" :popover="popover" :masks="masks">
									<template v-slot="{ inputValue, inputEvents, togglePopover}">
										<input :value="inputValue" v-on="inputEvents">
										<button class="icon-calendar" @click="togglePopover" type="button"><fa :icon="['far','calendar-alt']" class="icon fa-2x" /></button>
									</template>
								</DatePicker>
							</dd>
						</div>
					</dl>
				</div>
				<div class="flex justifycont-c center">
					<button class="btn_off" @click="cleardata(1)">クリア</button>
					<button class="btn_on" @click="searchdata([sisetu_name,bunya,kikan_from,kikan_to],1)">この条件で検索する</button>
				</div>
			</div>
        </div>
		<!-- 一覧・検索結果表示 -->
        <div class="inner">
			<div class="search_result">
				<p v-if="totalCount > 0">募集要項&ensp;<span style="font-weight:bold;">{{ totalCount }}</span>件見つかりました</p>
				<p v-else>条件に該当する施設はありません</p>
			</div>
			<!-- 凡例（仮置き） -->
			<div class="hanreis">
				<div class="hanrei">
					<fa :icon="['far','question-circle']" class="icon help_icon" />アイコンについて
					<dl>
						<dt class="detail_title">募集中ボランティア</dt>
						<dd class="detail_content">
							<ul class="flex ukeire_box">
								<li><span class="ukeire ukeire_syogaku">小</span>…小学生</li>
								<li><span class="ukeire ukeire_cyugaku">中</span>…中学生</li>
								<li><span class="ukeire ukeire_koko">高</span>…高校生</li>
								<li><span class="ukeire ukeire_tansen">短</span>…短大・専門学生</li>
								<li><span class="ukeire ukeire_daigaku">大</span>…大学生</li>
								<li><span class="ukeire ukeire_syuhu">主</span>…主婦/主夫</li>
								<li><span class="ukeire ukeire_kaisya">会</span>…会社員</li>
								<li><span class="ukeire ukeire_korei">齢</span>…高齢者</li>
								<li><span class="ukeire ukeire_syogai">障</span>…障がい者</li>
							</ul>
						</dd>
						<dt class="detail_title">内容 <span class="henko">※変更があります</span></dt>
						<dd class="detail_content">募集要項に変更点があります。</dd>
					</dl>
				</div>
				<div class="hanrei">
					<fa :icon="['far','question-circle']" class="icon help_icon" />学生ポイント制度とは
					<dl>
						<dt><span class="ukeire_tag_g">学生ポイント制度対象</span></dt>
						<dd class="detail_content">青森市内高等学校生徒・大学生・専門学校生を対象とした制度です。詳しくは<a href="http://www.aomoricity-shakyo.or.jp/volunteer/taikenvol_studentpoint.html" target="_blank" class="text-underline">ボランティアセンターホームページ</a>をご覧ください。</dd>
					</dl>
				</div>
				<div class="hanrei">
					<fa :icon="['far','question-circle']" class="icon help_icon" />地域福祉サポーターとは
					<dl>
						<dt><span class="ukeire_tag">地域福祉サポーター対象</span></dt>
						<dd class="detail_content">満18歳以上（高校生は除く）で市内に居住または通勤・通学している方を対象とした制度で、地域福祉活動の参加者のことです。詳しくは<a href="http://www.aomoricity-shakyo.or.jp/volunteer/vol_point.html" target="_blank" class="text-underline">ボランティアセンターホームページ</a>をご覧ください。</dd>
					</dl>
				</div>
			</div>
			<!-- ページ遷移表示 -->
			<div class="pagination">
				<base-pagination
					:show-pages="showPages"
					:current-page="currentPage"
					:total-count="totalCount"
					:total-pages="totalPages"
					:per-page="perPage"
					@currentPage="changePage"
				/>
			</div>
			<div class="list_area">
				<menu-item v-bind:items="lists" />
			</div>
			<!-- ページ遷移表示 -->
			<base-pagination
				:show-pages="showPages"
				:current-page="currentPage"
				:total-count="totalCount"
				:total-pages="totalPages"
				:per-page="perPage"
				@currentPage="changePage"
			/>
		</div>
    </div>
</template>

<script>
import { defineComponent , computed, ref, inject } from 'vue'
import MenuItem from './MenuItem.vue';
import BasePagination from './BasePagination.vue';
import axios from 'axios';
import common from '../static/common';
import { format } from 'date-fns'
import { DatePicker } from 'v-calendar';

export default defineComponent({
    name: 'cont',
    components: {
        MenuItem,
		BasePagination,
		DatePicker,
    },
    setup () {
		const { login } = inject('loginstate');
		const { ResetKatudo } = inject('kmosikomi');

		const res = ref([]); //APIのレスポンス
		//活動分野のデータを取得
		const bunya_lists = ref([]);  //活動分野のデータ
		async function getbunya_listsdata(){
		res.value = await axios.get('/api/common/bunya')
		bunya_lists.value = res.value.data
		}
		getbunya_listsdata();

		//ページネーションの初期値設定
		const currentPage = ref(1); //現在のページ
		const showPages = ref(5); //ページネーションの表示件数
		const perPage = ref(5); //1ページの表示件数

		const totalCount = ref(0); //データの総件数
		const lists = ref([]);  //表示する基データ
		const lists_params = ref([]);  //データ表示のパラメータ
		//検索キーワード
		const kw_params = ref([]);
		const sisetu_name = ref('');
		const bunya = ref('');
		const kikan_from = ref('');
		const kikan_to = ref('');

		let kw_sisetu_name = ref('');
		let kw_bunya = ref('');
		let kw_kikan_from = ref('');
		let kw_kikan_to = ref('');
		kw_sisetu_name = '';
		kw_bunya = '';
		kw_kikan_from = '';
		kw_kikan_to = '';

		// 初期値（今日）
		kikan_from.value = format(new Date(), 'yyyy-MM-dd')
		// 三か月後まで(仮)
		let nextMonth = new Date();
		nextMonth.setMonth(nextMonth.getMonth() + 3);
		kikan_to.value = format(nextMonth, 'yyyy-MM-dd')

		//一覧表示する基データを取得
		async function getlistsdata(){
		kw_sisetu_name = common.nvl(sisetu_name.value.replace(/^s+|s+$/g,''),'');
		kw_kikan_from = common.nvl(kikan_from.value,'');
		kw_kikan_to = common.nvl(kikan_to.value,'');
		kw_params.value ={
			name:common.nvl(kw_sisetu_name,''),
			bunya:common.nvl(kw_bunya,''),
			from:common.nvl(String(kw_kikan_from).replace(/-/g,""),''),
			to:common.nvl(String(kw_kikan_to).replace(/-/g,""),''),
			display:perPage.value,  //1ページの表示件数
			page:1 //表示件数で区切った分のうち、xxページめを指定
		}
		res.value = await axios.get('/api/bosyu_data/search',{params:kw_params.value})
		lists.value = res.value.data[0]
		//パラメータ初期値の設定
		lists_params.value = res.value.data[1]
		totalCount.value = lists_params.value[0].totalCount //データ型確認
		// totalPages.value = lists.value[1].totalPages
		ResetKatudo();
		}
		getlistsdata();

		// 検索
		// 検索ボタンイベント
		async function searchdata(keywords){
			console.log(keywords)
		kw_sisetu_name = common.nvl(keywords[0].replace(/^s+|s+$/g,''),'');
		kw_bunya = common.nvl(keywords[1],'');
		kw_kikan_from = common.nvl(keywords[2],'');
		kw_kikan_to = common.nvl(keywords[3],'');
		kw_params.value ={
			name:kw_sisetu_name,
			bunya:kw_bunya,
			// from:common.nvl(String(kw_kikan_from),''),
			// to:common.nvl(String(kw_kikan_to),''),
			from:common.nvl(String(kw_kikan_from).replace(/-/g,""),''),
			to:common.nvl(String(kw_kikan_to).replace(/-/g,""),''),
			display:perPage.value,  //1ページの表示件数
			page:1  //表示件数で区切った分のうち、xxページめを指定
		}
		getdata(kw_params.value)
		// 現在のページを更新 データ取得後は先頭ページを表示する
		clickedPageNumber.value = 1;
		currentPage.value = 1;
		}
		// クリア
		async function cleardata(){
		//入力フォームの初期化
		this.kikan_from_d = '';
		this.kikan_to_d = '';
		sisetu_name.value = '';
		bunya.value = '';
		kikan_from.value = '';
		kikan_to.value = '';
		//変数の初期化
		kw_sisetu_name = '';
		kw_bunya = '';
		kw_kikan_from = '';
		kw_kikan_to = '';
		kw_params.value ={
			name: kw_sisetu_name,
			bunya:kw_bunya,
			from:kw_kikan_from,
			to:kw_kikan_to,
			display:perPage.value,  //1ページの表示件数
			page:1  //表示件数で区切った分のうち、xxページめを指定
		}
		getdata(kw_params.value)
		// 現在のページを更新 データ取得後は先頭ページを表示する
		clickedPageNumber.value = 1;
		currentPage.value = 1;
		}
		// データ取得
		async function getdata(kw_params){
		// 検索文字列で絞り込み、検索文字列がない場合は全件取得
		res.value = await axios.get('/api/bosyu_data/search',{params:kw_params})
		// 配列にセット
		lists.value = res.value.data[0]
		//パラメータ初期値の設定
		lists_params.value = res.value.data[1]
		totalCount.value = lists_params.value[0].totalCount //データ型確認
		}
		
		//ページネーション
		//perPageに基づいたページ総数
		const totalPages = computed(() =>
		Math.ceil(totalCount.value / perPage.value)
		)
		//現在のページを取得
		const clickedPageNumber = ref(0);
		const changePage = (pageNumber) => {
		kw_params.value ={
			name:kw_sisetu_name,
			bunya:kw_bunya,
			from:common.nvl(String(kw_kikan_from).replace(/-/g,""),''),
			to:common.nvl(String(kw_kikan_to).replace(/-/g,""),''),
			display:perPage.value,  //1ページの表示件数
			page:pageNumber  //○ページめ
		}
		console.log(kw_params.value)
		getdata(kw_params.value)
		clickedPageNumber.value = pageNumber;
		currentPage.value = pageNumber;
		};

		return {
			login,
			ResetKatudo,
			bunya_lists,
			lists,
			// ページング
			changePage,
			clickedPageNumber,
			currentPage,
			perPage,
			showPages,
			totalCount,
			totalPages,
			// 検索
			sisetu_name,
			bunya,
			kikan_from,
			kikan_to,
			searchdata,  // 抽出処理
			cleardata,
			// 共通関数
			common,
			format,

		}
    },
	data() {
		let nextMonth = new Date();
		nextMonth.setMonth(nextMonth.getMonth() + 3);
		// let pop_value = "right"
		// if(screen.width <= 767) {
		// 	pop_value = "auto"
		// }
		return {
			kikan_from_d: new Date(),
			kikan_to_d: nextMonth,
			popover: {
				placement: "bottom",
				positionFixed: true
			},
			masks: {
				title: "YYYY年 MMMM"
			}
		}
	},
	// 検索条件で絞り込む時の表示
	// computed: {
	// 	search_message() {
	// 		if(!this.bunya && !this.sisetu_name && !this.kikan_from && !this.kikan_to) {
	// 			return ''
	// 		} else {
	// 			return '（絞り込みあり）'
	// 		}
	// 	}
	// },
	watch: {
		kikan_from_d(day) {
			if(day) {
				this.kikan_from = format(day, 'yyyy-MM-dd');
			} else {
				this.kikan_from = "";
			}
		},
		kikan_to_d(day) {
			if(day) {
				this.kikan_to = format(day, 'yyyy-MM-dd');
			} else {
				this.kikan_to = "";
			}
		}
	}
});

</script>

<style scoped>
span.search_message {
	margin-left: 1em;
	font-weight: bold;
}

br.search_message_off {
	display: none;
}
@media screen and (max-width: 425px) {
	br.search_message_off {
		display: block;
	}
}
</style>